// hero-toggle-icons.js

document.addEventListener('DOMContentLoaded', () => {
  // Initialize every hero-toggle-icons section on the page
  document
    .querySelectorAll('[id^="hero-toggle-icons-"]')
    .forEach(root => {
      const radios     = root.querySelectorAll('.paint-radio');
      const indicator  = root.querySelector('.toggle-indicator');
      const labels     = root.querySelectorAll('.toggle-option');
      const lists      = {
        peelable : root.querySelector('.icon-list[data-type="peelable"]'),
        permanent: root.querySelector('.icon-list[data-type="permanent"]')
      };
      const animChoice = root.getAttribute('data-icon-anim');
      const grid       = root.querySelector('.icon-grid');

      // Ensure icon‐grid never collapses when swapping
      function lockGridHeight() {
        const h = Math.max(
          lists.peelable.scrollHeight,
          lists.permanent.scrollHeight
        );
        grid.style.minHeight = h + 'px';
      }
      window.addEventListener('load',  lockGridHeight);
      window.addEventListener('resize', lockGridHeight);
      lockGridHeight();

      // Play entrance animation
      function play(list) {
        list.dataset.anim = animChoice;
        list.classList.add('pre-enter');
        list.querySelectorAll('.icon-item')
            .forEach((el,i) => el.style.setProperty('--stagger', i));
        // force reflow
        void list.offsetHeight;
        list.classList.add('enter-active');
        setTimeout(() => {
          list.classList.remove('pre-enter','enter-active');
        }, 450);
      }

      // Swap logic: highlight label, move indicator, show correct list
      function update() {
        const val = root.querySelector('.paint-radio:checked').value;

        // active label styling
        labels.forEach(l => {
          l.classList.toggle('active', l.dataset.value === val);
        });

        // slide & recolor indicator
        indicator.style.transform = val === 'permanent'
          ? 'translateX(100%)'
          : 'translateX(0%)';
        indicator.style.background = val === 'permanent'
          ? getComputedStyle(root).getPropertyValue('--toggle-2-bg')
          : getComputedStyle(root).getPropertyValue('--toggle-1-bg');

        // show/hide icon‐lists
        Object.entries(lists).forEach(([key,list]) => {
          const show = key === val;
          list.classList.toggle('hidden', !show);
          if (show) play(list);
        });
      }

      // initial state + listeners
      update();
      radios.forEach(radio => radio.addEventListener('change', update));
    });
});
